import React from 'react'

import ErrorCard from '@/CandidateExperience/components/ErrorCard'

const JobNotFoundScene = () => {
  return (
    <ErrorCard
      image="404-sheep.png"
      altText="404"
      heading="meh"
      subheading="We can't seem to find the job you're looking for."
      cta={{
        label: 'Back home',
        href: '/',
      }}
    />
  )
}

export default JobNotFoundScene
